module.exports = __webpack_public_path__ + "img/japan-diabetes-mellitus-female.93acf4ba.png";